import { getData } from "./fetchData";
import { Produkt } from "../store/types/organizacje";

export const organizacjeService = {
  dodaj,
  przegladaj,
  daj,
  edytuj,
  usun,
  dajZaproszenie,
  odrzucZaproszenie,
  potwierdzZaproszenie,
};

function dodaj(nazwa: string, produkty: Produkt[]) {
  return getData(`organizacja/dodaj`, {
    Nazwa: nazwa,
    Produkty: produkty,
  });
}

function przegladaj() {
  return getData(`organizacja/przegladaj`, {});
}

function daj(id: string) {
  return getData(`organizacja/daj`, {
    Id: id,
  });
}

function edytuj(id: string, nazwa: string, produkty: Produkt[]) {
  return getData(`organizacja/zmien`, {
    Id: id,
    Nazwa: nazwa,
    Produkty: produkty,
  });
}

function usun(id: string) {
  return getData(`organizacja/usun`, {
    Id: id,
  });
}

function dajZaproszenie(idOrganizacji: string, idZaproszenia: string) {
  return getData(`organizacja/zaproszenia/odczytaj`, {
    IdOrganizacji: idOrganizacji,
    IdZaproszenia: idZaproszenia,
  });
}

function potwierdzZaproszenie(idOrganizacji: string, idZaproszenia: string) {
  return getData(`organizacja/zaproszenia/potwierdz`, {
    IdOrganizacji: idOrganizacji,
    IdZaproszenia: idZaproszenia,
  });
}

function odrzucZaproszenie(idOrganizacji: string, idZaproszenia: string) {
  return getData(`organizacja/zaproszenia/odrzuc`, {
    IdOrganizacji: idOrganizacji,
    IdZaproszenia: idZaproszenia,
  });
}
